import { render, staticRenderFns } from "./approve-fill.vue?vue&type=template&id=05f2fd41&scoped=true"
import script from "./approve-fill.vue?vue&type=script&lang=js"
export * from "./approve-fill.vue?vue&type=script&lang=js"
import style0 from "./approve-fill.vue?vue&type=style&index=0&id=05f2fd41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2fd41",
  null
  
)

export default component.exports